import { defineComponent as _defineComponent } from 'vue'
import Icon from "../../components/Icon.vue";
import { computed } from 'vue';
import { IProductDetailProductJson } from 'JS/types/PDP';
import { PDPRootState } from 'JS/pdp/state/types';
import { Prop65WarningType } from "JS/types/Product";
import { useBreakpoints } from 'JS/composables/breakpoint';
import { useLegacyVuexStore } from 'JS/composables/legacy-vuex-store';

// TODO: is this component potentially reusable?


export default /*#__PURE__*/_defineComponent({
  __name: 'Prop65Warning',
  setup(__props) {

const vuexStore = useLegacyVuexStore<PDPRootState>();
const { isMobile } = useBreakpoints();

const product = computed<IProductDetailProductJson>(() => vuexStore.state.product);
const hasWarning = computed(() => !(product.value.prop65Warning == Prop65WarningType.NoWarning || product.value.prop65Warning == Prop65WarningType.Unknown));
const warningText = computed(() => {
	switch (product.value.prop65Warning) {
		case Prop65WarningType.Cancer:
			return "Cancer";
		case Prop65WarningType.ReproductiveHarm:
			return "Reproductive Harm";
		case Prop65WarningType.Full:
			return "Cancer & Reproductive Harm";
		default:
			return "";
	}
});

return { __sfc: true,vuexStore, isMobile, product, hasWarning, warningText, Icon }
}

})